import type { EnglishTestRecordBody, FreeQuestionnaireBody, FreeQuestionnaireParams, PsychologicalTestResultBody, PsychologicalTestResultResponse } from '@/models/interface/aiChat';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

export class AiChatQuestionnaireService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 建立 免費諮詢問卷(寄送 Email)
   * @param body - 問卷內容
   * @param params - 額外參數
   */
  createQuestionnaireV(
    body: FreeQuestionnaireBody[],
    params?: FreeQuestionnaireParams
  ): Promise<ApiDataResponse<string | null>> {
    return super.post(`v2/Questionnaire/Answer/free_consult`, body, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: { ...params }
    });
  }

  /**
   * 建立 學習性格測驗結果
   * @param body - 學習性格測驗結果
   */
  createPsychologicalTestResult(
    body: PsychologicalTestResultBody[],
  ): Promise<ApiDataResponse<undefined>> {
    return super.post(`v2/Questionnaire/Answer/Personality_Animal`, body, {
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  /**
   * 取得 學習性格測驗結果
   */
  getPsychologicalTestResult(
  ): Promise<ApiDataResponse<PsychologicalTestResultResponse[]>> {
    return super.get(`v2/Questionnaire/RecordList/Personality_Animal`);
  }

  /**
   * 建立 英文測驗等級 (綁定顧問會寄送 Email)
   * @param body - 等級級距字串
   */
  createEnglishTestRecord(
    body: EnglishTestRecordBody,
  ): Promise<ApiDataResponse<undefined>> {
    return super.post(`v1/Questionnaire/RecordEnglishTest`, body);
  }
}
